import style from "./style.scss";
import { Fragment, toChildArray, cloneElement } from "preact";
import { useId } from "preact/hooks";
import { usePopup } from "../popup/context";
import { mergeClasses } from "../helpers";
import ButtonList from "./button-list";
import Button from "./button";
import Popup from "../popup";
import Editorial from "../editorial";

const cloneIfVNode = (child, props) =>
  typeof child === "object" && child !== null && "type" in child
    ? cloneElement(child, props)
    : child;

const StickyButtons = ({
  class: className = null,
  title = null,
  description = null,
  children = null,
  options = null,
  ...props
}) => {
  const mergedClass = mergeClasses([style.stickyButtons, className]);
  const items = toChildArray(children);

  const popup = usePopup();
  const modalTitleId = useId();

  const openPopup = (e, optionData) => {
    e.preventDefault();
    popup.showPopup(
      <Popup ariaLabelledBy={modalTitleId}>
        <div class={style.popupWrapper}>
          <Editorial>
            <h4 id={modalTitleId}>Which Model?</h4>

            {optionData.options.map((option, i) => (
              <Fragment key={i}>
                <ButtonList>
                  <Button
                    href={option.href}
                    affiliate={option.affiliate}
                    affiliateData={option.affiliateData}
                    external={option.external}
                    blank={option.blank}
                    target={option.target}
                    rel={option.rel}
                    class={option.class}
                    icon={optionData.icon}
                    secondary={optionData.secondary}
                  >
                    {option.text}
                  </Button>
                </ButtonList>
              </Fragment>
            ))}
          </Editorial>
        </div>
      </Popup>
    );
  };

  return (
    <aside class={mergedClass} {...props}>
      <div class={style.wrapper}>
        {title ? (
          <div class={style.details}>
            <h3 class={style.title}>{title}</h3>
            <div>{description}</div>
          </div>
        ) : null}
        {children ? (
          <div style={style.stickyButtonGroup}>
            <div class={style.stickyLarge}>
              <ButtonList>
                {items.map((child, i) => (
                  <Fragment key={i}>{child}</Fragment>
                ))}
              </ButtonList>
            </div>
            <div class={style.stickyMedium}>
              <ButtonList size="medium">
                {items.map((child, i) => (
                  <Fragment key={i}>
                    {cloneIfVNode(child, { size: "medium" })}{" "}
                  </Fragment>
                ))}
              </ButtonList>
            </div>
          </div>
        ) : (
          <div style={style.stickyButtonGroup}>
            <div class={style.stickyLarge}>
              <ButtonList>
                {options.map((option, i) => (
                  <Fragment key={i}>
                    <Button
                      icon={option.icon}
                      secondary={option.secondary}
                      onClick={(e) => openPopup(e, option)}
                    >
                      {option.text}
                    </Button>
                  </Fragment>
                ))}
              </ButtonList>
            </div>
            <div class={style.stickyMedium}>
              <ButtonList size="medium">
                {options.map((option, i) => (
                  <Fragment key={i}>
                    <Button
                      size="medium"
                      icon={option.icon}
                      secondary={option.secondary}
                      onClick={(e) => openPopup(e, option)}
                    >
                      {option.text}
                    </Button>
                  </Fragment>
                ))}
              </ButtonList>
            </div>
          </div>
        )}
      </div>
    </aside>
  );
};

export default StickyButtons;
